<template>  
    <div v-if="this.$store.getters.token!=null">
         <TopToolbar /> 
         <v-container fluid >
            <router-view></router-view>
        </v-container>
    </div>
</template>
<style>
#app{
    background-color:#FFF!important;
}
</style>
<script>
import TopToolbar from "../../components/shared/topbar.vue";
export default {
    components: {
        TopToolbar
    },
    created:function(){       
            this.$store.dispatch("user_authenticate_refresh", true);
       
    },
    data: () => ({
        
    }),
    methods:{
        
    }
};
</script>